import axios from '@/api/axiosInstance';

export default async function getMe() {
  const response = await axios({
    url: `${process.env.NEXT_PUBLIC_API}/me`,
  });
  return response.data;
}
